import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { ApiUrl } from "../../constants";
import { UserApi } from "../user/user.api";
import {
  AuthFormData,
  ForgetPasswordFormData,
  LoginResult,
  RegisterFormData,
  RegisterSocialFormData,
  ResetPasswordFormData,
} from "./auth.type";

export const AuthApi = createApi({
  tagTypes: ["auth"],
  reducerPath: "auth",
  baseQuery: fetchBaseQuery({
    baseUrl: `${ApiUrl}/api`,
  }),
  endpoints: (builder) => ({
    register: builder.mutation<LoginResult["data"], RegisterFormData>({
      query: (data) => ({
        url: `/auth/register/`,
        method: "POST",
        body: data,
      }),
      transformResponse: ({ data }) => data,
      invalidatesTags: ["auth"],
    }),

    // Premiere etape : elle ne renvoie plus de jeton mais `otp_requis`,
    // le code partant par email.
    login: builder.mutation<LoginResult, AuthFormData>({
      query: (data) => ({
        url: `/auth/login/`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["auth"],
      onCacheEntryAdded(arg, { dispatch }) {
        dispatch(UserApi.util.invalidateTags(["user"]));
        //   dispatch(CandidatureApi.util.invalidateTags(["candidatures"]));
      },
    }),
    verifierCodeConnexion: builder.mutation<
      LoginResult,
      { email: string; code: string }
    >({
      query: (body) => ({
        url: `/auth/login/verifier/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["auth"],
    }),
    renvoyerCodeConnexion: builder.mutation<{ message: string }, string>({
      query: (email) => ({
        url: `/auth/login/renvoyer-code/`,
        method: "POST",
        body: { email },
      }),
    }),

    forgetPassword: builder.mutation<any, ForgetPasswordFormData>({
      query: (data) => ({
        url: `/request-password-reset/`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["auth"],
    }),
    resetPassword: builder.mutation<any, ResetPasswordFormData>({
      query: (data) => ({
        url: `/reset-password/`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["auth"],
    }),
    registerSocial: builder.mutation<LoginResult, RegisterSocialFormData>({
      query: (data) => ({
        url: `/auth/registersocial/`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["auth"],
    }),
  }),
});

export const {
  useRegisterMutation,
  useLoginMutation,
  useVerifierCodeConnexionMutation,
  useRenvoyerCodeConnexionMutation,
  useForgetPasswordMutation,
  useResetPasswordMutation,
  useRegisterSocialMutation,
} = AuthApi;
